var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Kevin Nguyen <kevin@sequentech.io>
// SPDX-FileCopyrightText: 2023, 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { Box, CircularProgress } from "@mui/material";
import styled from "@emotion/styled";
import { Stats } from "./Stats";
import { VotesPerDay } from "../charts/VotesPerDay";
import { daysBefore, formatDate, getToday } from "../charts/Charts";
import { VotersByChannel, VotingChanel } from "../charts/VotersByChannel";
import { useRecordContext } from "react-admin";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useQuery } from "@apollo/client";
import { GET_ELECTION_STATS } from "@/queries/GetElectionStats";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { ListIpAddress } from "@/resources/ElectionEvent/ListIpAddress";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
var Container = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n"])));
export default function DashboardElection() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var record = useRecordContext();
    var endDate = getToday();
    var startDate = daysBefore(endDate, 6);
    var userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var authContext = useContext(AuthContext);
    var showIpAdresses = authContext.isAuthorized(true, authContext.tenantId, IPermissions.ELECTION_IP_ADDRESS_VIEW);
    // Ensure required parameters are set before running the query.
    var canQueryStats = Boolean(tenantId && (record === null || record === void 0 ? void 0 : record.election_event_id) && (record === null || record === void 0 ? void 0 : record.id));
    var _r = useQuery(GET_ELECTION_STATS, {
        variables: {
            tenantId: tenantId,
            electionEventId: record === null || record === void 0 ? void 0 : record.election_event_id,
            electionId: record === null || record === void 0 ? void 0 : record.id,
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
            electionAlias: (_a = record === null || record === void 0 ? void 0 : record.alias) !== null && _a !== void 0 ? _a : undefined,
            userTimezone: userTimezone,
        },
        pollInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        skip: !canQueryStats,
    }), loading = _r.loading, dataStats = _r.data;
    if (loading) {
        return _jsx(CircularProgress, {});
    }
    var stats = (_c = (_b = dataStats === null || dataStats === void 0 ? void 0 : dataStats.election) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.statistics;
    var metrics = {
        eligibleVotersCount: (_e = (_d = dataStats === null || dataStats === void 0 ? void 0 : dataStats.users) === null || _d === void 0 ? void 0 : _d.count) !== null && _e !== void 0 ? _e : "-",
        votersCount: (_g = (_f = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _f === void 0 ? void 0 : _f.total_distinct_voters) !== null && _g !== void 0 ? _g : "-",
        areasCount: (_j = (_h = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _h === void 0 ? void 0 : _h.total_areas) !== null && _j !== void 0 ? _j : "-",
        emailsSentCount: (_k = stats === null || stats === void 0 ? void 0 : stats.num_emails_sent) !== null && _k !== void 0 ? _k : "-",
        smsSentCount: (_l = stats === null || stats === void 0 ? void 0 : stats.num_sms_sent) !== null && _l !== void 0 ? _l : "-",
    };
    var cardWidth = 470;
    var cardHeight = 250;
    return (_jsx(Box, __assign({ sx: { width: 1024, marginX: "auto" } }, { children: _jsxs(Box, { children: [_jsx(Stats, { metrics: metrics }), _jsxs(Container, { children: [_jsx(VotesPerDay, { data: (_o = (_m = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _m === void 0 ? void 0 : _m.votes_per_day) !== null && _o !== void 0 ? _o : null, width: cardWidth, height: cardHeight, endDate: endDate }), _jsx(VotersByChannel, { data: [
                                {
                                    channel: VotingChanel.Online,
                                    count: (_q = (_p = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _p === void 0 ? void 0 : _p.total_distinct_voters) !== null && _q !== void 0 ? _q : 0,
                                },
                                {
                                    channel: VotingChanel.Paper,
                                    count: 0,
                                },
                                {
                                    channel: VotingChanel.Telephone,
                                    count: 0,
                                },
                                {
                                    channel: VotingChanel.Postal,
                                    count: 0,
                                },
                            ], width: cardWidth, height: cardHeight })] }), showIpAdresses && (record === null || record === void 0 ? void 0 : record.id) && (_jsx(ListIpAddress, { electionEventId: record === null || record === void 0 ? void 0 : record.election_event_id, electionId: record === null || record === void 0 ? void 0 : record.id }))] }) })));
}
var templateObject_1;
